import { render, staticRenderFns } from "./xcx.vue?vue&type=template&id=4f0059f4&scoped=true&"
import script from "./xcx.vue?vue&type=script&lang=js&"
export * from "./xcx.vue?vue&type=script&lang=js&"
import style0 from "./xcx.vue?vue&type=style&index=0&id=4f0059f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0059f4",
  null
  
)

export default component.exports